export default {
  1: '微笑',
  2: '撇嘴',
  3: '色',
  4: '发呆',
  5: '得意',
  6: '流泪',
  7: '害羞',
  8: '闭嘴',
  9: '睡',
  10: '大哭',
  11: '尴尬',
  12: '发怒',
  13: '调皮',
  14: '呲牙',
  15: '惊讶',
  16: '难过',
  17: '酷',
  18: '冷汗',
  19: '抓狂',
  20: '吐',
  21: '偷笑',
  22: '可爱',
  23: '白眼',
  24: '傲慢',
  25: '饥饿',
  26: '困',
  27: '惊恐',
  28: '流汗',
  29: '憨笑',
  30: '大兵',
  31: '奋斗',
  32: '咒骂',
  33: '疑问',
  34: '嘘...',
  35: '晕',
  36: '折磨',
  37: '衰',
  38: '骷髅',
  39: '敲打',
  40: '再见',
  41: '擦汗',
  42: '抠鼻',
  43: '鼓掌',
  44: '糗大了',
  45: '坏笑',
  46: '左哼哼',
  47: '右哼哼',
  48: '哈欠',
  49: '鄙视',
  50: '委屈',
  51: '快哭了',
  52: '阴险',
  53: '亲亲',
  54: '吓',
  55: '可怜',
  56: '菜刀',
  57: '西瓜',
  58: '啤酒',
  59: '篮球',
  60: '乒乓',
  61: '咖啡',
  62: '饭',
  63: '猪头',
  64: '玫瑰',
  65: '凋谢',
  66: '示爱',
  67: '爱心',
  68: '心碎',
  69: '蛋糕',
  70: '闪电',
  71: '炸弹',
  72: '刀',
  73: '足球',
  74: '瓢虫',
  75: '便便',
  76: '月亮',
  77: '太阳',
  78: '礼物',
  79: '拥抱',
  80: '强',
  81: '弱',
  82: '握手',
  83: '胜利',
  84: '抱拳',
  85: '勾引',
  86: '拳头',
  87: '差劲',
  88: '爱你',
  89: 'no',
  90: 'ok',
  91: '爱情',
  92: '飞吻',
  93: '跳跳',
  94: '发抖',
  95: '怄火',
  96: '转圈',
  97: '磕头',
  98: '回头',
  99: '跳绳',
  100: '挥手',
  101: '跳高',
  102: '吼叫',
  103: '练武',
  104: '左摆',
  105: '右摆',
  106: '囍',
  107: '鞭炮',
  108: '灯笼',
  109: '发',
  110: '麦克风',
  111: '手袋',
  112: '信',
  113: '帅',
  114: '庆祝',
  115: '蜡烛',
  116: '生气',
  117: '棒棒糖',
  118: '奶瓶',
  119: '面条',
  120: '香蕉',
  121: '飞机',
  122: '汽车',
  123: '车头',
  124: '车厢',
  125: '车尾',
  126: '多云',
  127: '下雨',
  128: '钞票',
  129: '熊猫',
  130: '灯泡',
  131: '风车',
  132: '闹钟',
  133: '雨伞',
  134: '气球',
  135: '钻戒',
  136: '沙发',
  137: '厕纸',
  138: '药丸',
  139: '手枪',
  140: '青蛙'
}
